import { useEffect, useState } from "react";

import {
  type Transportista,
  fetchTransportistas,
} from "~/services/transportistaService";

export const useTransportistas = () => {
  const [transportistas, setTransportistas] = useState<Transportista[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadTransportistas = async (useCache = true) => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await fetchTransportistas(useCache);
      setTransportistas(data);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to load transportistas";
      setError(errorMessage);
      console.error("Error loading transportistas:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTransportistas();
  }, []);

  const refreshTransportistas = () => loadTransportistas(false);

  return {
    transportistas,
    isLoading,
    error,
    refreshTransportistas,
    loadTransportistas,
  };
};
